import React, { useState, useEffect, useRef } from 'react';
import {
  Modal, ModalHeader, ModalBody,
  Card, CardBody, ButtonToolbar, ButtonGroup, Row, Col, Badge
} from 'reactstrap';
import { Dialog } from 'primereact/dialog';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import classNames from 'classnames';
import Moment from 'moment';
import moment from 'moment'
import { load as loadAccount } from './../../redux/reducers/commonReducer';
import { Field, reduxForm } from 'redux-form';
import { connect } from 'react-redux';
import PropTypes, { element } from 'prop-types';
import { withTranslation } from 'react-i18next';
import { Link, useSearchParams } from 'react-router-dom';
import PaginatorComponent from '../Cruds/CommonDataTable/PaginatorComponent';
import html2pdf from 'html2pdf.js';
import { Document, Packer, Paragraph, TextRun } from 'docx';
import { saveAs } from 'file-saver';

//components
import AutoComplete from './components/AutoComplete';
import CalendarBlankIcon from 'mdi-react/CalendarBlankIcon';
import Select from '../../shared/components/form/Select';
import RadioButton from '../../shared/components/form/RadioButton';
import DefaultInput from '../../shared/components/form/DefaultInput';
import DefaultTextArea from '../../shared/components/form/DefaultTextArea';
import DatePicker from '../../shared/components/form/DatePicker';
import TimePicker from '../../shared/components/form/TimePicker';
import renderRadioButtonField from '../../shared/components/form/RadioButton';
import UserPasswordResetModal from '../Cruds/CommonModals/UserPasswordResetModal';
import { Dropdown } from 'primereact/dropdown';
import RenderFileInputField from '../Form/components/FileUpload';
// import {CKEditor} from 'ckeditor4-react';
import { Editor } from 'react-draft-wysiwyg';
import { EditorState } from 'draft-js';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import TextEditorTwo from '../../shared/components/TextEditor';

import config from '../../config/config';
import configMessages from '../../config/configMessages';
import apiCalls from '../../config/apiCalls';
import fetchMethodRequest from '../../config/service';
import DataTables from '../Cruds/CommonDataTable/DataTable';
// Toaster message
import showToasterMessage from '../UI/ToasterMessage/toasterMessage';
import { toast } from 'react-toastify';
import EyeIcon from 'mdi-react/EyeIcon';
import dateFormats from '../UI/FormatDate/formatDate';
import validate from '../Validations/validate';

// Multi select Dropdown
import MultiSelectDropDown from './components/MultiSelect';

// Loader
import Loader from '../App/Loader';
// Calendar
//session expiry modal
import DeleteRowModal from '../Cruds/CommonModals/DeleteRowModal';
import SessionExpiryModal from '../Cruds/CommonModals/SessionexpiryModal'
//import TicketCommentsInfo from '../Tables/PrimeReactTable/Tickets/components/TicketCommentsInfo';
import { th } from 'date-fns/locale';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Scrollbar from 'smooth-scrollbar-react';
import { useForm, Controller } from 'react-hook-form';
import { Button } from 'primereact/button';
import DoInputField from "./Fields/DoInputField";
import DoPasswordField from "./Fields/DoPasswordField";
import DoDateField from './Fields/DoDateField';
import DoSelectField from './Fields/DoSelectField';
import DoTextareaField from './Fields/DoTextareaField';
import DoMultiSelectField from './Fields/DoMultiSelectField';
import DoRadioButtons from './Fields/DoRadioButtons';
import DoCheckboxField from './Fields/DoCheckboxField';
import DoAutoCompleteField from './Fields/DoAutoCompleteField';
import DoEditor from './Fields/DoEditor';
import { getPasswordRegex } from './DoValidations';
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import DoFileUpload from './Fields/DoFileUpload';
import { stripHtmlTags } from '../../utils/utils';
import { marked } from 'marked';



let radioRequired = value => {
  let error = undefined;
  if (value || typeof value === 'string') {
    error = undefined
  } else {
    error = configMessages.fillRadio
  }
  return error
}
let required = value => (value || typeof value === 'string' ? undefined : configMessages.fillField);
let normalizePhone = (value) => {
  if (!value) {
    return value
  }
  let onlyNums = value.replace(/[^\d]/g, '')
  if (onlyNums.length <= 3) {
    return onlyNums
  }
  if (onlyNums.length <= 7) {
    return `${onlyNums.slice(0, 3)}-${onlyNums.slice(3)}`
  }
  return `${onlyNums.slice(0, 3)}-${onlyNums.slice(3, 6)}-${onlyNums.slice(6, 10)}`
}


let FormModal = (props) => {

  let [displayBreadCrumbValue, setDisplayBreadCrumbValue] = useState(props.displayBreadCrumbValue);
  let [displayBreadCrumbField, setDisplayBreadCrumbField] = useState(props.displayBreadCrumbField);
  let [userStatus, setUserStatus] = useState(props.userStatus);
  let [formFields, setFormFields] = useState(props.formFields());
  let [formValues, setFormValues] = useState({});
  let [colored, setColored] = useState(false);
  let [header, setHeader] = useState(true);
  let [isLoading, setIsLoading] = useState(false);
  let [defaultValue, setDefaultValue] = useState(true);
  let [roleOptions, setRoleOptions] = useState([]);
  let [slno, setSslno] = useState(0);
  let [rowData, setRowData] = useState([]);
  let [originalTableFields, setOriginalTableFields] = useState(props.originalTableFields);
  let [actions, setActions] = useState('');
  let [confirmType, setConfirmType] = useState('');
  let [confirmModalText, setConfirmModalText] = useState('');
  let [activitiesData, setActivitiesData] = useState([]);
  let [totalRecordsLength, setTotalRecordsLength] = useState(0);
  let [first, setFirst] = useState(0);
  let [rows, setRows] = useState(10);
  let [page, setPage] = useState(1)
  let [showorHideLevelsField, setShoworHideLevelsField] = useState(false);
  let [filterCriteria, setFilterCriteria] = useState({ limit: 10, page: 1, criteria: [], sortfield: 'created', direction: 'desc' });
  let [editRowDataID, setEditRowDataID] = useState();
  let [formType, setFormType] = useState(props.formType);
  let [userData, setUserData] = useState();
  let [menuList, setMenuList] = useState(props.menuList ? props.menuList : []);
  let [selectActions, setSelectActions] = useState();
  let [selectedRows, setSelectedRows] = useState();
  let [sortCount, setSortCount] = useState();

  let [sessionExpiryModal, setSessionExpiryModal] = useState(false);
  let [openUserPasswordResetModal, setOpenUserPasswordResetModal] = useState(false);
  let [openDeleteModal, setOpenDeleteModal] = useState(false);
  let [dropValueForEdit, setDropValueForEdit] = useState('');
  // let [isEditFields, setIsEditFields] = useState(false);
  let [selectedData, setSelectedData] = useState({});
  let [selectedId, setSelectedId] = useState(props.selectedId);

  let [schema, setSchema] = useState('');
  const [copyText, SetCopyText] = useState(false);

  const [searchParams] = useSearchParams();
  const moduleId = searchParams.get("module");
  const [customViewData, setCustomViewData] = useState();
  const [focusedField, setFocusedField] = useState(null);
  const previewRef = useRef(null);
  const isElementInViewport = (el) => {
    const rect = el.getBoundingClientRect();
    return (
      rect.top >= 0 &&
      rect.left >= 0 &&
      rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
      rect.right <= (window.innerWidth || document.documentElement.clientWidth)
    );
  };

  useEffect(() => {
    if (focusedField && previewRef.current) {
      const element = previewRef.current.querySelector(`[data-variable="${focusedField}"]`);
      if (element && !isElementInViewport(element)) {
        element.scrollIntoView({
          behavior: 'smooth',
          block: 'center',
        });
      }
    }
  }, [focusedField]);

  useEffect(() => {

    /**@Changing indexValue of the modal */

    const modal = document.querySelector('div[tabindex="-1"][style*="z-index: 1050;"]');
    if (modal) {
      modal.style.zIndex = '300';
    }

    let tschema = setValidations(props.formFields());
    setSchema(tschema)
    let sessionexpired = localStorage.getItem('sessionexpired');
    if (sessionexpired) {
      setSessionExpiryModal(true);
    }
    if (formType !== "add") {
      // getActivities();
      const recordId = selectedId ? selectedId : props.tableRowData.id;
      const selected = getSelectedData(recordId, props.allUsersData);
      console.log(props.allUsersData)
      setSelectedData(selected);
    } else {
      setSelectedData(null);
    }

    if (formType === 'view') {
      const recordId = selectedId ? selectedId : props.tableRowData.id;
      const selected = getSelectedData(recordId, props.allUsersData);
      setSslno(selected.Sno)
      handleViewDisplay(selected, formType);
    }
    else if (formType === 'edit') {
      console.log(selectedData)
      getRowData(selectedData, 'edit');
    }
    else if (formType === 'regenerate') {
      getRowData(selectedData, 'regenerate');
    }

    //This is for correct working of forms when fields are provided with default values
    if (formType === 'add') {
      let fields = props.formFields();
      fields.forEach((item) => {

        if (item.value && item.name) {
          setValue(item.name, item.type === 'date' ? new Date(item.value) : item.value)
        }
      })
    }

    // if (formType !== 'view') {
    //   console.log(formFields, selectedData)
    //   formFields.map((obj) => {
    //     console.log(obj, obj.value, obj.name, selectedData[obj.name])
    //     if (obj.value && obj.name && !selectedData[obj.name]) {
    //       setValue(obj.name, obj.value)
    //     }
    //   })
    // }

  }, [selectedData, formType]);


  useEffect(() => {
    if (props.type === "Roles") {
      const setInitialValues = () => {
        setValue('permission', {});
        setValue('levels', 1);
        const permissionsData = generatePermissionsData();
        if (permissionsData && permissionsData.length > 0) {
          permissionsData.forEach(screen => {
            if (screen && screen.name) {
              setValue(screen.name, screen.value);
            }
          });
        }
      };
      setInitialValues();
    }
  }, [props.selectedId, props.allUsersData]);


  const {
    handleSubmit,
    register,
    reset,
    setValue,
    getValues,
    formState: { errors },
    control,
    watch
  } = useForm({
    resolver: yupResolver(schema),
    mode: "onChange",        // validate on each change
    reValidateMode: "onChange"
  });

  const getSelectedData = (id, allData) => {
    if (id && id.startsWith('"') && id.endsWith('"')) {
      id = JSON.parse(id);
      // Parse id as a JSON string
    }
    setSelectedId(id);
    const data = allData.filter((row) => row._id === id);
    return (data.length > 0) ? data[0] : [];
  }


  let setValidations = (fields) => {
    let valObj = {};
    fields.forEach((field) => {
      if (field?.show && ((!field.isAddFormHidden && formType === 'add') || (!field.isEditFormHidden && formType === 'edit')) && (field.required || ('validationRequired' in field && field.validationRequired == true))) {
        valObj[field.name] = getValidations(field);
      }
      if (field.type && (field.type == "email" || field.type == "relateAutoComplete")) {
        valObj[field.name] = getValidations(field);
      }
    });

    return yup.object().shape(valObj)

  }

  let getValidations = (field) => {
    // console.log(field)
    if (field.name === 'phone') {
      return yup
        .string()
        .required('Phone number is required')
        .matches(/^\d+$/, 'Phone number must contain only digits')
        .matches(/^\d{10}$/, 'Phone number must be exactly 10 digits')
        .test('phone', 'Phone number is invalid', function () {
          const { phone } = this.parent || {};
          if (phone && !yup.string().matches(/^\d{10}$/).isValidSync(phone)) {
            return this.createError({ path: 'phone', message: 'Phone number must be 10 digits' });
          }
          return true;
        });
    }

    if (field.type === 'number') {
      return yup.number().required(`${field.label} is a required field`);
    } else if (field.type === 'email' && field.required && field.required == true) {
      return yup.string().email().required(`${field.label} is a required field`);
    } else if (field.type === 'password') {
      return yup.string().required().matches(getPasswordRegex(), "Password must contain at least 8 characters, one uppercase, one number and one special case character")
    } else if ((field.type === "relateAutoComplete" && field.isMultiple) || (field && field.isMultiSelect && field.type == 'dropDown')) {
      return yup.array().required(`${field.label} is a required field`)
    } else if ((field.type === "relateAutoComplete" && field.required && field.required == true) || field.type === "permission") {
      return yup.object().typeError('Please select the value from dropdown').required(`${field.label} is a required field`)
    }
    /**@CheckBox */
    else if (field.type === 'checkbox') {
      if (field.required) {
        return yup.boolean().oneOf([true], 'Checkbox must be checked')
      } else {
        yup.boolean();
      }
    }

    //relateautocomplete validation for not required fields
    else if (field.type === "relateAutoComplete") {
      return yup.lazy(value => {
        if (value == null || value === '') {
          return yup.mixed().nullable().notRequired();
        }
        return yup
          .object()
          .nullable()
          .typeError('Select a valid option')
          .test('is-object', 'Select a valid option', v => typeof v === 'object');
      });
    }


    //regex pattern matching validation for required fields
    else if (field.type === 'text' && field.regexPattern && field.required == true) {
      return yup.string().required(`${field.label} is a required field`).test({
        name: 'check-regex',
        test: function (value, { originalValue }) {
          if (originalValue) {
            const reg = new RegExp(field.regexPattern);
            if (!reg.test(originalValue)) {
              const customErrorMessage = disp(field);
              throw this.createError({ path: field.name, message: customErrorMessage });
            }
          }
          return true;
        },
      });
    }

    //regex pattern matching validation for not required fields
    else if (field.type === 'text' && field.regexPattern) {
      return yup.string().test({
        name: 'check-regex',
        test: function (value, { originalValue }) {
          if (originalValue) {
            const reg = new RegExp(field.regexPattern);
            if (!reg.test(originalValue)) {
              const customErrorMessage = disp(field);
              throw this.createError({ path: field.name, message: customErrorMessage });
            }
          }
          return true;
        },
      });
    }

    //email validation when not required field
    else if (field.type === 'email') {
      return yup.string().test({
        name: 'email-regex',
        test: function (value, { originalValue }) {
          if (originalValue) {
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            if (!emailRegex.test(originalValue)) {
              throw this.createError({ path: field.name, message: 'Enter a valid email id' });
            }
          }
          return true;
        },
      });
    }

    /**@Text Validation */
    // else if(field.type == 'text' && field.regexPattern){
    //   let str=disp(field);
    //   return yup.string().required(`${field.label} is a required field`).matches(new RegExp(field.regexPattern),`${str}`);
    // }

    else if (field.type === 'WebSite') {
      const websiteRegex = /^(?:(?:(?:https?|ftp):)?\/\/)?(?:www\.)?[a-zA-Z0-9-]+(?:\.[a-zA-Z]{2,})+(?:\/[^\s]*)?$/;

      return yup.string().required(`${field.label} is a required field`).matches(websiteRegex, `Enter a valid URL`);
    }

    else {
      return yup.string().required(`${field.label} is a required field`);
    }
  }

  let disp = (f) => {
    let msg = "";
    let m = '';
    if (f.regexData.maxLengthRequired == true && f.regexData.showMaxField == true) {
      m = "Max length:" + f.regexData.maxLengthText + ", ";
      msg += m;
    }
    if (f.regexData.minLengthRequired == true && f.regexData.showMaxField == true) {
      m = "Min length:" + f.regexData.minLengthText + ", ";
      msg += m;
    }
    if (f.regexData.alphabetsRequired == true && f.regexData.showAlphaField == true) {
      m = "Letters" + ", ";
      msg += m;
    }
    if (f.regexData.numbersRequired == true && f.regexData.showNumField == true) {
      m = "Numbers" + ", ";
      msg += m;
    }
    if (f.regexData.showSCharField == true && f.regexData.specialCharRequired == true) {
      m = "Special characters:" + f.regexData.specialCharText + ", ";
      msg += m;
    }
    msg = msg.slice(0, -2);
    return msg;

  };


  let onPageChange = async (event) => {
    let filters = { ...filterCriteria };
    if (event && event.rows) {
      let currentPage = event.page + 1;
      filters['limit'] = event.rows;
      filters['page'] = currentPage;
      setRows(event.rows);
      setPage(event.page);
      setFirst(event.first)
    }
    await getActivities(filters, selectedId);
  }

  let getTableFields = () => {
    let data = [
      {
        show: true,
        mobile: true,
        textAlign: 'center',
        width: 100,
        field: 'created',
        fieldType: 'Date',
        type: 'date',
        header: 'Created',
        filter: true,
        sortable: true,
        dateFormat: config.dateDayMonthFormat
      },
      {
        show: true,
        mobile: true,
        textAlign: 'center',
        width: 100,
        field: 'contextType',
        header: 'Context Type',
        filter: true,
        sortable: true
      },
      {
        show: true,
        mobile: true,
        textAlign: 'left',
        width: 250,
        fieldType: 'Array',
        field: 'description',
        header: 'Description',
        filter: true,
        sortable: true
      },

    ];
    return data;
  };
  let getPaginator = () => {
    return (
      <PaginatorComponent
        totalRecords={totalRecordsLength}
        first={first}
        rows={rows}
        onPageChange={onPageChange}
        isWeb={true}
      />
    )
  }
  let getActivities = async () => {
    let tFilterCriteria = filterCriteria;
    let urlHeading = window.location.href;
    let userID = decodeURIComponent(urlHeading.split('/').pop());
    let userIDWithoutQuotes = userID.replace(/^"(.*)"$/, '$1');
    userIDWithoutQuotes = userIDWithoutQuotes.replace(/"/g, '');
    tFilterCriteria['criteria'] = [{ key: 'contextId', value: userIDWithoutQuotes, type: 'eq' }];
    let url = `activities?filter=${JSON.stringify(tFilterCriteria)}`
    return fetchMethodRequest('GET', url).then(async (response) => {
      if (response) {
        let responseData = '',
          //  totalRecordsLength = totalRecordsLength;
          dateFormat;
        // let responseData = '', totalRecordsLength = totalRecordsLength;
        if (response && response['activities'] && response['activities'].length && response['activities'].length >= 0) {
          if (response.pagination && response.pagination.totalCount) {
            totalRecordsLength = response.pagination.totalCount;
          }
          responseData = updateDateFormat(response['activities'], dateFormat);
        } else {
          if (response.pagination && (response.pagination.totalCount || response.pagination.totalCount == 0)) {
            totalRecordsLength = response.pagination.totalCount;
          }
        }

        setActivitiesData(responseData);
        setTotalRecordsLength(totalRecordsLength);
        setFilterCriteria(tFilterCriteria)

      }
    }).catch((err) => {
      return err
    })
  }

  let getTableFieldItem = async (field) => {
    for (let i = 0; i < props.tablefieldsToShow.length; i++) {
      if (props.tablefieldsToShow[i].field == field) {
        return props.tablefieldsToShow[i];
      }
    }
    return null;
  }
  let getFormFields = async () => {

    if (props.formFields()) {
      let displayFormFields = formFields;
      let sortType = '';
      if (formType === 'add') {
        sortType = 'addFormOrder';
      } else if (formType === 'edit') {
        sortType = 'editFormOrder';
      }
      if (sortType) {
        let sortFields = [];
        let otherFields = [];
        for (let i = 0; i < displayFormFields.length; i++) {
          if (displayFormFields[i][sortType]) {
            sortFields.push(displayFormFields[i]);
          }
          else {
            otherFields.push(displayFormFields[i]);
          }
          if (formType === 'add') {
            setValue(displayFormFields[i].name, displayFormFields[i].value);
          }
        }
        sortFields = sortFields.sort((a, b) => a[sortType] - b[sortType]);
        displayFormFields = [...sortFields, ...otherFields];
        displayFormFields = displayFormFields.sort((a, b) => a[sortType] - b[sortType]);
      }
      setFormFields(displayFormFields);
      setValidations(displayFormFields);

    }
  }

  let getFormFieldItem = async (key) => {
    let formFields = await props.formFields();
    for (let i = 0; i < formFields.length; i++) {
      if (formFields[i].name === key) {
        return formFields[i];
      }
    }
    return null;
  }
  //close delete modal
  let closeDeleteModal = async () => {
    setState({
      openDeleteModal: false,
      actions: ''
    })
  }
  let handleNextAndBackActions = async (sno) => {
    let { allUsersData } = props;
    let data = allUsersData.find((obj) => obj.Sno === sno)
    setUserData(data);
    setSelectedId(data['_id']);
    if (formType === 'view') {
      setEditRowDataID(data['_id']);
      await handleViewDisplay(data, 'view');
    } else {
      await getRowData(data, 'edit')
    }
    setFilterCriteria({ limit: 10, page: 1, criteria: [], sortfield: 'created', direction: 'desc' });
    setFirst(0);
    setRows(10);
    setTotalRecordsLength(0)
    await getActivities(null, data['_id']);
  }

  let getViewData = async (rowData, type, rowDataIndex, userData, _id) => {
    setRowData(rowData);
    setCustomViewData(props.allUsersData.filter(i => i._id == _id)[0]);
    setEditRowDataID(_id);
    setFormType(type);
    // setSslno(rowDataIndex);
    setUserData(userData);
  };
  let getIconValue = (rowData, labelKey) => {
    if (labelKey && labelKey.options && labelKey.options.length > 0) {
      for (let i = 0; i < labelKey.options.length; i++) {
        if (labelKey.options[i].value === rowData[labelKey.field]) {
          return labelKey.options[i].displayText;
        }
      }
    }
    return '';
  }

  async function handleViewDisplay(rowData, type) {
    let _id = rowData['_id'];
    let rowDataIndex = rowData['Sno']
    let keys = Object.keys(rowData);
    let newFields = [];
    if (newFields) {
      if (props.type) {
        if (rowData) {
          let values, fieldType, searchField, icon = false;

          keys.forEach(async function (key) {
            let labelKey = '';
            for (let i = 0; i < props.tablefieldsToShow.length; i++) {
              if (props.tablefieldsToShow[i].field == key) {
                labelKey = props.tablefieldsToShow[i];

                if (labelKey == null) {
                  labelKey = key;
                } else {
                  let val = rowData[key];
                  if (labelKey.fieldType === 'icon') {
                    val = getIconValue(rowData, labelKey);
                    icon = true;
                  }
                  fieldType = labelKey.fieldType ? labelKey.fieldType : null
                  searchField = labelKey.searchField ? labelKey.searchField : null
                  let options = labelKey.options ? labelKey.options : []
                  let isMul = labelKey.isMultiple ? labelKey.isMultiple : false
                  labelKey = labelKey.header
                  if (val) {
                    if (fieldType && searchField && isMul && fieldType == "relateAutoComplete") {
                      let displayNames = rowData[key].map((item) => {
                        return item[searchField];
                      });
                      let displayNamesString = displayNames.join(', ');

                      values = {
                        label: labelKey,
                        value: icon ? val : displayNamesString,
                        fieldType: fieldType
                      }
                    } else
                      if (fieldType && searchField && fieldType == "relateAutoComplete") {
                        values = {
                          label: labelKey,
                          value: icon ? val : rowData[key][searchField],
                          fieldType: fieldType
                        }
                      } else if (fieldType && fieldType == "fileUpload" && rowData[key] && rowData[key].length > 0) {
                        values = {
                          label: labelKey,
                          value: rowData[key].map((filePath, index) => (
                            <div key={index}>
                              <Link to={`${config.imgUrl}${props.type.toLowerCase()}/${filePath}`} target="_blank" style={{ textDecoration: "none" }}>
                                {filePath}
                              </Link>
                            </div>
                          )),
                          fieldType: fieldType,
                          options: options
                        }
                      } else {
                        values = {
                          label: labelKey,
                          value: icon ? val : rowData[key],
                          fieldType: fieldType,
                          options: options
                        }
                      }
                    newFields.push(values);
                    icon = false;
                  }
                }
              }
            }
          });
        }
      }
      setSelectedId(_id);
      setSelectedData(rowData);
      setFormType('view');
      setUserData(rowData);
      setDisplayBreadCrumbValue(rowData[displayBreadCrumbField]);
      setUserStatus(rowData['status'])
      await getViewData(newFields, 'view', rowDataIndex, rowData, _id);
    }
  }

  let getUserData = (_id) => {
    let data = props.allUsersData;
    for (let i = 0; i < data.length; i++) {
      if (data[i]['_id'] === _id) {
        return i
      }
    }
  }
  let updateDateFormat = (itemdata, dateFormat) => {
    let modifiedData = [];
    let tablefieldsToShow = getTableFields();
    for (let i = 0; i < itemdata.length; i++) {
      for (let k = 0; k < tablefieldsToShow.length; k++) {
        if ("Date" == tablefieldsToShow[k]['fieldType']) {
          itemdata[i][tablefieldsToShow[k]['field']] =
            dateFormats.formatDate(
              itemdata[i][tablefieldsToShow[k]['field']],
              tablefieldsToShow[k]['dateFormat']);
        }
      }
      modifiedData.push(itemdata[i])
    }
    return modifiedData;
  }
  //Get From Fields data on Edit
  let getRowData = async (selectedRowInfo, type, custtype) => {
    let keys = Object.keys(selectedRowInfo);
    let formFields = props.formFields();
    for (let i = 0; i < keys.length; i++) {
      let fieldItem = await getFormFieldItem(keys[i]);
      if (fieldItem) {
        // if ((fieldItem.type === 'multipleprofile' || fieldItem.type === 'ckeditor' || fieldItem.type === 'profile') && selectedRowInfo[fieldItem.name]) {
        //   setState({
        //     [fieldItem.name]: selectedRowInfo[fieldItem.name]
        //   })
        // }
        if (fieldItem.type === 'date') {
          const rawValue = selectedRowInfo[fieldItem.name];
          if (rawValue && !(rawValue instanceof Date)) {
            const formattedDate = fieldItem.dateFormat || config.dateDayMonthFormat;
            selectedRowInfo[fieldItem.name] = moment(rawValue, formattedDate).toDate();
          }
        }
        if (fieldItem.type === 'time') {
          let formattedTime = moment(selectedRowInfo[fieldItem.name], config.fullDateTimeFormat).toDate();
          selectedRowInfo[fieldItem.name] = formattedTime;
        }
        if (fieldItem.type === 'dropDown' && fieldItem.isMultiSelect) {
          selectedRowInfo[fieldItem.name] = selectedRowInfo[fieldItem.name]
        }
        else if (fieldItem.type === 'dropDown' && fieldItem.dependent && fieldItem.dependent.length > 0) {
          let displayFormFields = formFields;
          if (fieldItem.dependent && fieldItem.dependent.length > 0) {
            for (let i = 0; i < fieldItem.dependent.length; i++) {
              if (selectedRowInfo && selectedRowInfo[fieldItem.name] === Object.keys(fieldItem.dependent[i])[0]) {
                if (fieldItem.dependent[i][Object.keys(fieldItem.dependent[i])[0]] && fieldItem.dependent[i][Object.keys(fieldItem.dependent[i])[0]].length > 0) {
                  displayFormFields = await showField(displayFormFields, fieldItem.dependent[i][Object.keys(fieldItem.dependent[i])[0]], true);
                }
              }
            }

            await setFormFields(displayFormFields);
          }
        }
      }
    }
    if (props.type && props.type == "Roles" && selectedRowInfo.roleType && selectedRowInfo.roleType == "Manager") {
      setShoworHideLevelsField(true);
    }

    // if (selectedRowInfo['permissions']) {
    //   let permissionsArray = []
    //   let permissions = selectedRowInfo['permissions']
    //   if (permissions) {
    //     let keys = Object.keys(permissions);
    //     keys.forEach((element) => {
    //       if (element) {
    //         selectedRowInfo[element] = permissions[element];
    //         let permissonObj = {
    //           title: element,
    //         }
    //         if (type === 'edit') {
    //           if (selectedRowInfo[element] === 'Edit') {
    //             permissonObj.Edit = false;
    //           } else if (selectedRowInfo[element] === 'View') {
    //             permissonObj.View = false;
    //           } else if (selectedRowInfo[element] === 'NoView') {
    //             permissonObj.NoView = false;
    //           }
    //         } else {
    //           if (selectedRowInfo[element] === 'Edit' || selectedRowInfo[element] === 'View') {
    //             selectedRowInfo[element] = 'NoView';
    //             permissonObj.NoView = false;
    //           }
    //         }
    //         permissionsArray.push(permissonObj);
    //       }
    //     });
    //   }

    //   setMenuList(permissionsArray);
    // }
    if (props.load) {
      props.load(selectedRowInfo);
    }

    let fields = props.formFields();
    fields.forEach((item) => {
      if (!(item.isEditFormHidden === true && formType === 'edit') || formType === 'regenerative') {
        setTimeout(() => {
          setValue(item.name, selectedRowInfo[item.name])
        }, 100)
      }
    })



    setIsLoading(false);
    setEditRowDataID(selectedRowInfo._id);
    setDisplayBreadCrumbValue(selectedRowInfo[displayBreadCrumbField]),
      setFormType(type);
    setUserData(selectedRowInfo);
  }

  if (props.onRef) {
    props.onRef({
      handleViewDisplay,
      getRowData,
    });
  }

  let closeFormModal = async () => {
    if (props.displayName === 'Home' || props.type === 'Files') {
      props.getDataFromServer();
      props.closeFormModal();
    } else {
      clearFormFields();
      // props.getDataFromServer();
      props.closeFormModal();
    }
  }

  let flattenArray = (arrayVal) => {
    let val = '';
    if (arrayVal) {
      val = JSON.stringify(arrayVal);
      val = val.replace(/"/g, '')
        .replace(/\[/g, '')
        .replace(/]|\\/g, '')
        .replace(/{/g, '')
        .replace(/}/g, '')
        .replace(/,/g, ' , ')
        .replace(/:/g, ' : ');
    }
    return val;
  }
  let getActivtiesTableFieldItem = (field) => {
    let tablefieldsToShow = getTableFields()
    for (let i = 0; i < tablefieldsToShow.length; i++) {
      if (tablefieldsToShow[i].field == field) {
        return tablefieldsToShow[i];
      }
    }
    return null;
  }
  // hari need to move to derived class or controller
  let changeFieldValues = (item, column) => {
    let self = this, tableItem;
    tableItem = self.getActivtiesTableFieldItem(column.field);
    if (tableItem.fieldType === "Array") {
      let val = flattenArray(item[column.field]);
      return <span style={tableItem.style} title={val}>
        {val}
      </span>
    } else {
      if ((item[column.field]) && typeof item[column.field] !== 'object') {
        return item[column.field];
      }
    }
  }
  // form Submit
  let submit = (values) => {
    if (values.roleType != "Manager") {
      values.levels = 1;
    }
    if (props.type === 'testCase') {
      if (moduleId) {
        values.moduleId = moduleId;
      }
    }

    if (props.type === 'agreementFiles') {
      values.htmlContent = generateAgreementHTML();
    }

    for (let formField of formFields) {
      if (formField.fieldType == "relateAutoComplete") {
        if (!formField.isMultiple && values[formField.name] && values[formField.name][formField.searchField]) {
          values[formField.name + "Search"] = values[formField.name][formField.searchField]
        } else if (formField.isMultiple && values[formField.name]) {
          let finalString = '';
          if (values[formField.name]?.length > 0) {
            values[formField.name].forEach(val => {
              if (formField.searchField) {
                finalString += val[formField.searchField] + ',';
              }
            })
          }
          values[formField.name + "Search"] = finalString;
        } else {
          values[formField.name] = null;
          values[formField.name + "Search"] = null;
        }
      }
    }
    let request = values
    if (props.assingValueToForm) {
      request = Object.assign(request, props.assingValueToForm);
    }

    delete values.created;
    delete values.updated;

    if (values && Object.keys(values).length > 0) {
      Object.keys(values).map(key => {
        if (typeof values[key] === 'string') {
          values[key] = values[key].trim()
        }
        return key;
      })
      saveDataToServer(values);
    } else {
      return;
    }
  }

  let clearFormFields = async () => {
    if (props.load) {
      props.load({});
    }
    let formData = [...formFields];
    formData.forEach((item) => {
      item.value = '';
      item.invalid = false;
      item.message = ''
    });
    await setFormFields(formData)
    getFormFields();
  }

  let onEditorChange = async (evt) => {
    setState({
      [evt.editor.name]: evt.editor.getData()
    });
  }
  let ObjectbyString = (o, s) => {
    s = s.replace(/\[(\w+)\]/g, '.$1'); // convert indexes to properties
    s = s.replace(/^\./, '');           // strip a leading dot
    var a = s.split('.');
    for (var i = 0, n = a.length; i < n; ++i) {
      var k = a[i];
      if (k in o) {
        o = o[k];
      } else {
        return;
      }
    }
    return o;
  }
  //send data to server
  let saveDataToServer = async (formValues) => {
    /**@CheckBox */
    Object.keys(formValues).forEach(key => {
      if (formValues[key] === undefined) {
        let formField = formFields.filter(d => d.name == key);
        if (formField && formField?.[0] && formField[0].type == 'checkbox') {
          formValues[key] = "false";
        }
      }
    });

    let userBody = Object.assign({}, formValues);
    let validationExists;
    setIsLoading(true);
    if (!validationExists) {
      if (formValues) {
        let method, apiUrl;

        if (formType === 'edit') {
          if (props.type !== 'Tickets') {
            delete userBody.email
          }
          delete userBody.password;
          method = 'PUT';
          apiUrl = `${props.apiUrl}/${editRowDataID}`;
          if (props.type === "Folders") {
            apiUrl = `${props.apiUrl}/${editRowDataID}`;

            const originalPath = userBody.path;
            const prefix = "server/upload/folders/";
            const newPath = originalPath?.replace(prefix, "");
            userBody.path = newPath;

          } else if (props.type === "files") {
            const originalPath = userBody.path;
            const prefix = "server/upload/folders/";
            const newPath = originalPath?.replace(prefix, "");
            userBody.path = newPath;
          }
          //  else if (props.type === 'Files' && formType === 'edit') {
          //   delete userBody.levels;
          //   if (userBody.multiFile) {
          //     userBody.files = userBody.multiFile; // Rename multiFile to file
          //     delete userBody.multiFile;
          //   }
          // }
        } else if (formType === 'view') {
          delete userBody.email
          delete userBody.password;
          method = 'PUT';
          apiUrl = `${props.apiUrl}/${editRowDataID}`;

        } else {
          method = 'POST';
          apiUrl = props.apiUrl;
          if (props.type === 'Files' && formType === 'add') {
            delete userBody.levels;
            if (userBody.multiFile) {
              userBody.files = userBody.multiFile; // Rename multiFile to file
              delete userBody.multiFile;
            }
          }
        }

        for (let i = 0; i < formFields.length > 0; i++) {
          if (formFields[i].show === false)
            continue;
          if (formFields[i].type === 'autoComplete') {
            if (formFields[i]["options"] && formFields[i]["options"].length > 0) {
              for (let j = 0; j < formFields[i]["options"].length; j++) {
                let keys = Object.keys(formFields[i]["options"][j])
                let values = Object.values(formFields[i]["options"][j]);
                if (keys && keys[0] && values && values[0] && formValues[formFields[i]["name"]][values[0]]) {
                  userBody[keys[0]] = formValues[formFields[i]["name"]][values[0]];
                }
              }
            }
          }
          if (formFields[i].type === 'multipleprofile' || formFields[i].type === 'profile') {
            // userBody[formFields[i].name] = formFields[i].name;
            userBody[formFields[i].name] = userBody[formFields[i].name];
          }
          if (formFields[i].type === 'permission') {
            let permissions = {};
            let keys = Object.keys(formValues);
            menuList.forEach((item, index) => {
              keys.forEach((key) => {
                if (item.title === key) {
                  permissions[item.title] = formValues[key]
                }
              })
            })
            userBody.permissions = { ...permissions }
          }
        }
        if (props.type == "testCase" && formType == "regenerate") {
          method = 'POST';
          apiUrl = `${props.apiUrl}/regenerateTestCases`;
          userBody._id = selectedData._id
        }
        if (props.type == "agreementFiles") {
          if (formType == "add") {
            method = 'POST';
            apiUrl = `${props.apiUrl}`;
          }
          else {
            method = 'PUT';
            apiUrl = `${props.apiUrl}/${selectedData._id}`;
          }
          userBody.templateId = props.currentTemplate?._id

          Object.keys(userBody).forEach(key => {
            const fieldDef = formFields.find(f => f.name === key);
            if (fieldDef && fieldDef.type === 'date') {
              userBody[key] = moment(userBody[key]).format(config.dateDBFormat);
            }
          });

          formFields.forEach(field => {
            if (field.type === 'date' && userBody[field.name]) {
              userBody[field.name] = moment.utc(userBody[field.name]).format(config.dateDBFormat);
            }
          });

        }


        return fetchMethodRequest(method, apiUrl, userBody)
          .then(async (response) => {
            let sessionexpired = await localStorage.getItem('sessionexpired')
            if (sessionexpired === "true") {
              setSessionExpiryModal(true);
            }
            if (props.type === 'Create Agreement') {
              if (response.messages) {
                props.onSuccessSave(response)
              }
            }
            if (response && response.respCode) {
              if (formType !== 'add')
                if (props.softUpdate && props.replaceUpdatedData) {
                  if (response.details) {
                    props.replaceUpdatedData(response.details);
                  } else if (response[props.type]) {
                    props.replaceUpdatedData(response[props.type]);
                  } else {
                    props.replaceUpdatedData(response, userBody);
                  }
                } else {
                  await props.getDataFromServer(props.filterCriteria);
                }
              else
                await props.getDataFromServer();
              showToasterMessage(response.respMessage, 'success');
              if (props.displayViewOfForm === 'modal') {
                props.closeFormModal();
              } else {
                if (formType !== 'add') {
                  props.closeFormModal('save', response.quantityId);
                } else {
                  props.closeFormModal('save', response.quantityId);
                }

              }
              clearFormFields();
              props.reset();
            } else if (response && response.errorMessage) {
              showToasterMessage(response.errorMessage, 'error');
            }

            setIsLoading(false);
          }).catch((err) => {
            return err;
          });
      } else {
        return;
      }
    }
  }

  //getStores
  let getRecords = (valve, key, apiUrl, name) => {
    let filterCriteria = {}
    filterCriteria['criteria'] = [{ key: key, value: valve, type: 'eq' }];
    let url = `${apiUrl}?filter=${JSON.stringify(filterCriteria)}`
    fetchMethodRequest('GET', url).then(async (response) => {
      if (response) {
        let states = response[apiUrl];
        let roleOptions = [];
        if (states && states.length > 0) {
          for (let i = 0; i < states.length; i++) {
            roleOptions.push({ label: states[i][name], value: states[i][name] })
          }

          await setRoleOptions(roleOptions);
        } else {
          await setRoleOptions([]);
        }
      }
    }).catch((err) => {
      return err
    })
  }

  // //Handle auto complete data
  let handleAutoCompleteData = async (value, name) => {

  }

  let getDropdownMultiselect = (i, item) => {
    return (
      <div>
        <Controller
          name={item.name}
          control={control}
          render={({ field, fieldState }) => (
            <DoMultiSelectField
              markReq={item.required}
              input={field}
              id={field.id}
              name={field.name}
              field={field}
              fieldState={fieldState}
              errors={errors}
              label={item.label}
              options={item.options}
              optionLabel={item.optionLabel}
              placeholder={item.placeholder}
            />)}
        />
      </div>
    )
  }

  let handleFnEnableControlsBasedOnValue2 = async (e, dependent) => {
    let formFields = props.formFields();
    if (dependent && dependent.length > 0) {
      for (let i = 0; i < dependent.length; i++) {
        if (e && e === Object.keys(dependent[i])[0]) {
        }
        else {
          if (dependent[i][Object.keys(dependent[i])[0]] && dependent[i][Object.keys(dependent[i])[0]].length > 0) {
            formFields = await showField(formFields, dependent[i][Object.keys(dependent[i])[0]], false);
          }
        }
      }
      for (let i = 0; i < dependent.length; i++) {
        if (e && e === Object.keys(dependent[i])[0]) {
          if (dependent[i][Object.keys(dependent[i])[0]] && dependent[i][Object.keys(dependent[i])[0]].length > 0) {
            formFields = await showField(formFields, dependent[i][Object.keys(dependent[i])[0]], true);
          }
        }
      }
      await setFormFields(formFields)
      const schema = setValidations(formFields);
      setSchema(schema);
    }
  }
  let handleFnEnableControlsBasedOnValue = async (e, dependent) => {
    if (e && e == "Manager") {
      setShoworHideLevelsField(true);
    } else {
      setShoworHideLevelsField(false);
    }
  }

  let getDropdown = (i, item) => {
    return (
      <div>
        <Controller
          name={item.name}
          control={control}
          render={({ field, fieldState }) => (
            <DoSelectField
              input={field}
              markReq={item.required}
              id={field.id}
              name={field.name}
              field={field}
              label={item.label}
              fieldState={fieldState}
              errors={errors}
              options={item.options}
              optionLabel={item.optionLabel ? item.optionLabel : 'label'}
              placeholder={item.placeholder}
              item={item}
              screenName={props.screenName}
              handleFnEnableControlsBasedOnValue={handleFnEnableControlsBasedOnValue}
              handleFnEnableControlsBasedOnValue2={handleFnEnableControlsBasedOnValue2}
              disable={item.isDisable}
            />)}
        />
      </div>
    )
  }

  let showField = (formFields, itemNames, show = true) => {
    let value = true;
    if (show === false) {
      value = show;
    }
    for (let i = 0; i < formFields.length; i++) {
      for (let itemName of itemNames) {
        if (formFields[i].name === itemName) {
          formFields[i].show = value;
        }
      }
    }
    return formFields;
  }

  const generatePermissionsData = () => {
    const options = [
      { label: 'NoView', value: 'NoView' },
      { label: 'View', value: 'View' },
      { label: 'Edit', value: 'Edit' }
    ];
    let permissions = {};
    if (formType === 'edit' && selectedId) {
      const rowData = props.allUsersData.find((obj) => obj._id === selectedId);
      if (rowData && rowData.permissions && typeof rowData.permissions === 'object') {
        permissions = { ...rowData.permissions };
      }
    }
    else if (formType == "edit" && props.tableRowData) {
      let rowData = props.tableRowData;
      if (rowData && rowData.permissions && typeof rowData.permissions === 'object') {
        permissions = { ...rowData.permissions };
      }
    }
    return menuList.map((screen) => {
      return screen.name ? {
        'name': screen.name,
        'value': permissions[screen.name] ? permissions[screen.name] : 'View',
        'options': options
      } : null;
    }).filter(item => item !== null);
  };


  const getScreenPermissions = () => {
    const permissionsData = generatePermissionsData();

    return (
      <div id="permission">
        <div className='permissions-header'>
          <h4 className='permissions-title'>
            Screen Permissions
          </h4>
        </div>

        <div className="permissions-table-container">
          <table className="permissions-table">
            <thead>
              <tr>
                <th className="screen-name">Screen</th>
                <th>Access Level</th>
              </tr>
            </thead>
            <tbody>
              {permissionsData && permissionsData.length > 0 && permissionsData.map((item, index) => (
                <tr key={index} className="permission-row">
                  <td className="screen-name">
                    {item.label || item.name}
                  </td>
                  <td>
                    {getRadio(index, item)}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    );
  };


  let getRolePermissions = () => {
    return (
      <div className="form form--horizontal">
        <div className="form__form-group row">
          <div className='col-sm-6' style={{ paddingLeft: '119px' }}>
            <span className='pr-4 pl-5'>{'Edit'}</span>
            <span className='pr-3 pl-2'>{'View'}</span>
            <span className='pr-2 '>{'No View'}</span>
          </div>
          <div className='col-sm-6' style={{ paddingLeft: '119px' }}>
            <span className='pr-4 pl-5'>{'Edit'}</span>
            <span className='pr-3 pl-2'>{'View'}</span>
            <span className='pr-2 '>{'No View'}</span>
          </div>
        </div>
        {menuList && menuList.length > 0 ?
          menuList.map((item, index) => {
            return <div key={index} className="form__form-group col-sm-6">
              <span className="form__form-group-label ">{item.title}</span>
              <div className="form__form-group-field ">
              </div>
            </div>
          }) : null
        }
      </div>
    );
  }

  let getFileUpload = (i, item) => {
    const bytesPerMB = 1024 * 1024;
    let fileSize = item.maxFileSize * bytesPerMB;
    let url = '';
    if (props?.assingValueToForm?.path && props?.assingValueToForm?.parentFolderId) {
      url = `files?path=${props?.assingValueToForm?.path}&folderId=${props?.assingValueToForm?.parentFolderId}?type=${item.imagePath.toLowerCase()}`
    } else {
      url = 'files'
    }
    return (
      <div>
        <Controller
          name={item.name}
          control={control}
          render={({ field, fieldState }) => (
            <DoFileUpload
              url={url}
              imagePath={item.imagePath.toLowerCase()}
              formType={formType}
              showPreview={true}
              // accept = {"image/*"}
              input={field}
              id={field.id}
              label={item.label}
              name={field.name}
              field={field}
              fieldState={fieldState}
              errors={errors}
              type={props.type}
              isMultiple={item.isMultipleRequired}
              maxFileSize={fileSize}
              closeFormModal={closeFormModal}
              assingValueToForm={props.assingValueToForm}
            />)}
        />
      </div>
    )
  }


  let getFileName = async (file, item) => {
    let image = file;
    await setState({
      [item.name]: image
    });
  }

  let getDate = (i, item) => {
    return (
      <div>
        <Controller
          name={item.name}
          control={control}
          render={({ field, fieldState }) => (
            <DoDateField
              markReq={item.required}
              input={field}
              id={field.id}
              name={field.name}
              field={field}
              fieldState={fieldState}
              onChange={field.onChange}
              onFocus={() => setFocusedField(field.name)}
              onBlur={() => setFocusedField(null)}
              errors={errors}
              value={field.value}
              placeholder="date"
              formType={formType}

            />)}
        />
      </div>
    )
  }

  let getTime = (i, item) => {
    return (
      <div>
        <Controller
          name={item.name}
          control={control}
          render={({ field, fieldState }) => (
            <DoDateField
              markReq={item.required}
              input={field}
              id={field.id}
              name={field.name}
              field={field}
              fieldState={fieldState}
              errors={errors}
              placeholder="time"
              timeOnly={true}
            />)}
        />
      </div>
    )
  }

  let getCkEditor = (i, item) => {
    let self = this;
    return (
      <div>
        <Controller
          name={item.name}
          control={control}
          render={({ field, fieldState }) => (
            <DoEditor
              label={item.label}
              field={field}
              errors={errors}
              disabled={item.disabled}
            />
          )}
        />
      </div>

      // <span>Testing</span>
    )
  }

  let getRadio = (i, item) => {
    item.label = item.label ? item.label : item.name;
    return (
      <div key={i}>
        <Controller
          name={item.name}
          control={control}
          render={({ field, fieldState }) => (
            <DoRadioButtons
              markReq={item.required}
              options={item.options}
              input={field}
              id={field.id}
              name={field.name}
              field={field}
              label={item.label}
              fieldState={fieldState}
              errors={errors}
              defVal={item.value}
            />)}
        />
      </div>
    )
  }

  let getAutoComplete = (i, item) => {
    return (
      <div>
        <Controller
          name={item.name}
          control={control}
          render={({ field, fieldState }) => (
            <DoAutoCompleteField
              markReq={item.required}
              input={field}
              id={field.id}
              name={field.name}
              field={field}
              filterField={item.filterField}
              filterValue={item.filterValue}
              filterType={item.isNotEq}
              multiple={item.isMultiple}
              fieldState={fieldState}
              errors={errors}
              screen={props.type}
              searchApi={item.searchApi}
              searchField={item.searchField}
              allow={props.allowDuplicates}
              filterFieldType={item.filterFieldType ? item.filterFieldType : null}
              placeholder={item.placeholder}
              label={item.label}
              item={item}
              getValues={getValues}
              watch={watch}
              setValue={setValue}
              disabled={item.disabled}
            />)}
        />
      </div>
    )
  }

  let getTextArea = (i, item) => {
    return (
      <div>
        <Controller
          name={item.name ? item.name : null}
          control={control}
          render={({ field, fieldState }) => (
            <DoTextareaField
              markReq={item.required}
              input={field}
              id={field.id}
              name={field.name}
              field={field}
              defVal={item.value}
              fieldState={fieldState}
              label={item.label}
              errors={errors}
              disabled={item.isDisable}
              rows={item.rows}
              placeholder={item.placeholder ? item.placeholder : null}
            />)}
        />
      </div>
    )
  }

  let getButtonGroup = (i, item) => {
    return (
      <ButtonToolbar className='mt-0'>
        <ButtonGroup size="sm" >
          {item.options.map((button) => {
            return <Button style={{ paddingTop: 3, paddingBottom: 3 }}
              color="primary"
              outline size="sm"
              active={state[`is${button.label}ReOrder`]}
              onClick={() => handleReOrdering(button.value)}>{button.label}</Button>
          })
          }
        </ButtonGroup>
      </ButtonToolbar>
    )
  }

  let getDefault = (i, item) => {
    let { t } = props;
    const isDisable = props.formType === 'add' && item.isAddFieldDisable ? true : props.formType === 'edit' && item.isEditFieldDisable ? true : item.isDisable ? true : false;
    return (
      <div>
        <Controller
          name={item.name ? item.name : null}
          control={control}
          render={({ field, fieldState }) => (
            <DoInputField
              markReq={item.required}
              input={field}
              id={field.id}
              name={field.name}
              label={item.label}
              field={field}
              // type={item.type ? item.type : "text"}
              type={item.type && item.type == "number" ? item.type : item.type == "currency" ? "number" : "text"}
              isCurrency={item.type == "currency"}
              currency={item.type == "currency" ? item.currency : "INR"}
              fieldState={fieldState}
              errors={errors}
              defVal={field.value}
              placeholder={item.placeholder ? item.placeholder : null}
              disable={isDisable}
              onFocus={() => setFocusedField(field.name)}
              onBlur={() => setFocusedField(null)}
            />)}
        />
      </div>
    )
  }
  /**@CheckBox Component */
  let getCheckbox = (i, item) => {
    let { t } = props;
    return (
      <div>
        <Controller
          name={item.name ? item.name : null}
          control={control}
          render={({ field, fieldState }) => {
            field.value = field.value ? field.value : false;
            return <DoCheckboxField
              markReq={item.required}
              input={field}
              id={field.id}
              name={field.name}
              label={item.label}
              field={field}
              type={item.type ? item.type : "text"}
              fieldState={fieldState}
              errors={errors}
              defaultChecked={false}
              placeholder={item.placeholder ? item.placeholder : null}
            />
          }}
        />
      </div>
    )
  }

  let getPassword = (i, item) => {
    let { t } = props;
    return (
      <div>
        <Controller
          name={item.name ? item.name : null}
          control={control}
          render={({ field, fieldState }) => (
            <DoPasswordField
              markReq={item.required}
              input={field}
              id={item.id ? item.id : null}
              name={field.name}
              field={field}
              fieldState={fieldState}
              errors={errors}
              placeholder={item.placeholder ? item.placeholder : null}
            />)}
        />
      </div>
    )
  }

  let showPassword = (e) => {
    e.preventDefault();
  }


  let getButtonToolbar = () => {
    let { t } = props;
    return (
      <div className='d-flex'>
        <div className='col-12 px-0'>
          <span className='float-end'>
            <ButtonToolbar>
              {props.displayViewOfForm === 'modal' && formType === 'add' ? <Button color='primary' type="button" onClick={() => closeFormModal()}>
                {t('Back') ? t('Back') : 'Back'}
              </Button> :
                props.displayViewOfForm === 'sideForm' ? <Button color='primary' type="button" onClick={() => closeFormModal()}>
                  {t('Close') ? t('Close') : 'Close'}
                </Button>

                  : formType !== 'add' ? <Button color='primary' type="button"
                    // onClick={() => setFormType("view")}
                    onClick={() => closeFormModal()}
                  >
                    {t('Back') ? t('Back') : 'Back'}
                  </Button> : formType === 'add' ? <Button color='primary' type="button" onClick={() => closeFormModal()}>
                    {t('Back') ? t('Back') : 'Back'}
                  </Button> : null}

              {
                props.type !== 'Files' && formType !== "regenerate" &&
                <Button color='primary' outline type="submit">
                  {formType && formType === 'add' ?
                    t('Save') ? t('Save') : 'Save'
                    : t('Update') ? t('Update') : 'Update'
                  }
                </Button>
              }

              {
                props.type === 'Files' && formType !== 'add' && formType !== "regenerate" ?
                  <Button color='primary' outline type="submit">
                    {t('Update') ? t('Update') : 'Update'}
                  </Button> : null
              }
              {props.type == "testCase" && formType == "regenerate" && <Button color='success' outline type="submit">
                <svg fill="currentColor" height="20" width="20" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                  <path
                    clip-rule="evenodd"
                    d="M9 4.5a.75.75 0 0 1 .721.544l.813 2.846a3.75 3.75 0 0 0 2.576 2.576l2.846.813a.75.75 0 0 1 0 1.442l-2.846.813a3.75 3.75 0 0 0-2.576 2.576l-.813 2.846a.75.75 0 0 1-1.442 0l-.813-2.846a3.75 3.75 0 0 0-2.576-2.576l-2.846-.813a.75.75 0 0 1 0-1.442l2.846-.813A3.75 3.75 0 0 0 7.466 7.89l.813-2.846A.75.75 0 0 1 9 4.5ZM18 1.5a.75.75 0 0 1 .728.568l.258 1.036c.236.94.97 1.674 1.91 1.91l1.036.258a.75.75 0 0 1 0 1.456l-1.036.258c-.94.236-1.674.97-1.91 1.91l-.258 1.036a.75.75 0 0 1-1.456 0l-.258-1.036a2.625 2.625 0 0 0-1.91-1.91l-1.036-.258a.75.75 0 0 1 0-1.456l1.036-.258a2.625 2.625 0 0 0 1.91-1.91l.258-1.036A.75.75 0 0 1 18 1.5ZM16.5 15a.75.75 0 0 1 .712.513l.394 1.183c.15.447.5.799.948.948l1.183.395a.75.75 0 0 1 0 1.422l-1.183.395c-.447.15-.799.5-.948.948l-.395 1.183a.75.75 0 0 1-1.422 0l-.395-1.183a1.5 1.5 0 0 0-.948-.948l-1.183-.395a.75.75 0 0 1 0-1.422l1.183-.395c.447-.15.799-.5.948-.948l.395-1.183A.75.75 0 0 1 16.5 15Z"
                    fill-rule="evenodd"
                  ></path>
                </svg>
                {t('Generate') ? t('Generate') : 'Generate'}
              </Button>}
            </ButtonToolbar>
          </span>
        </div>
      </div>
    )
  }

  let getData = (data, type) => {
    // setIsEditFields(true);
    setFormType(type)
    getRowData(data, type);
  }

  let getEditButton = () => {
    if (props.customViewModal) {
      return null;
    }
    let { t } = props;
    return (
      <>
        <div className='mx-1 d-flex justify-content-end my-2'>
          {
            <Button color='primary' outline type="submit" onClick={() => getData(userData, 'edit')}>
              {t('Edit') ? t('Edit') : 'Edit'}
            </Button>
          }
          <Link to={props.routeTo.startsWith("/") ? props.routeTo : `/${props.routeTo}`} onClick={closeFormModal}>&nbsp;&nbsp;
            <Button color='primary' outline type="submit"> Close </Button>
          </Link>
        </div>
      </>
    )
  }

  let getModalHeader = () => {
    let { t } = props;
    return (
      <ModalHeader className="modal__header">
        {/* <button className="lnr lnr-cross modal__close-btn" type="button" onClick={closeFormModal} /> */}
        <p className="bold-text  modal__title">
          {formType &&
            formType === 'edit' ?
            t('Edit') ? t('Edit') : 'Edit' :
            formType &&
              formType === 'view' ?
              t('View') ? t('View') : 'View' : t('Add') ? t('Add') : 'Add'
          }{' '}
          {props.type ? props.type : null}
        </p>
      </ModalHeader>
    )
  }

  let getDependentFields = (type, formType) => {
    return null;
  }

  let getMultiplePhotoUpload = (i, item) => {
    return (
      <div>
        <Field key={i}
          onRef={(ref) => (profileUploadRef = ref)}
          name={item.name ? item.name : null}
          component={RenderFileInputField}
          label={item.label}
          type='profile'
          id={'photo'}
          acceptType={'image/*'}
          url={apiCalls.LocationImagePath}
          getMulipleFileName={(file) => getMulipleFileName(file, item)}
          multiple={true}
        />
        <Scrollbar>
          <div className='mindivForMultipleupload' >
            {state[item.name] && state[item.name].length > 0 ? state[item.name].map((imagLocationItem, imagLocationIndex) => (<div className='col-md-2' style={{ padding: '20px' }}>
              <div key={imagLocationIndex} style={{ justifyContent: 'center' }}>
                <img
                  key={imagLocationIndex}
                  src={`${config.imgUrl}${item.imagePath}/${imagLocationItem['file']}`}
                  className='detailsImgStyle' />
                <FontAwesomeIcon icon='times-circle' className='timesCircleIcon'
                  onClick={() => removeMultipleUploadedImages(imagLocationIndex, item)}
                />
              </div>
            </div>)) : null
            }
          </div>
        </Scrollbar>
      </div>
    )
  }
  let getDeleteRowModal = () => {
    return (
      <DeleteRowModal
        openDeleteModal={openDeleteModal}
        closeDeleteModal={closeDeleteModal}
        selectActions={selectActions}
        deleteSelectedRow={handleActions}
        confirmModalText={confirmModalText}
      />
    )
  }
  // Store selected Images in state
  let getMulipleFileName = async (file, item) => {
    let multipleLocationImage = state[item.name];
    multipleLocationImage.push({ "file": file })
    await setState({
      [item.name]: multipleLocationImage
    });
  }

  // Remove selected image from state
  let removeMultipleUploadedImages = async (imagLocationIndex, item) => {
    let multipleLocationImage = state[item.name];
    multipleLocationImage.splice(imagLocationIndex, 1);
    await setState({
      [item.name]: multipleLocationImage
    })
  }

  let getItemField = (item, i) => {
    let { t } = props;
    return (
      <div id={item.name} key={props.type + i}
        className={(item.isAddFormHidden && formType === 'add') ? 'd-none' :
          item.name == "levels" && props.type == "Roles" && !showorHideLevelsField ? 'd-none' :
            (item.isEditFormHidden && formType === 'edit') ? 'd-none' : (item.type === 'ckeditor' || item.type === 'permission' || item.type === 'multipleprofile' ? 'col-sm-12' : (
              (item.type === 'autoComplete' && item.name === 'assignedTo') ||
                item.name === 'closebutton' ? 'col-sm-4' : item.type === 'fileUpload' ? 'col-sm' : displayViewOfForm == "sideForm" ? "col-sm-12" : item.customClass ? item.customClass : props.type == "agreementFiles" ? "col-sm-12" : "col-sm-6"))}
      >
        <div className="form__form-group mb-3 ml-1" >
          {/* <label className="form__form-group-label">
            {t(item.label)}
          </label> */}
          {item.type === 'dropDown' && item.isMultiSelect ?
            getDropdownMultiselect(i, item)
            : item.type === 'dropDown' ?
              getDropdown(i, item)
              : item.name === 'closebutton' ?
                getCloseButton(i, item)
                : item.type === 'fileUpload' ?
                  getFileUpload(i, item)
                  : item.type === 'date' ?
                    getDate(i, item)
                    : item.type === 'time' ?
                      getTime(i, item)
                      : item.type === 'ckeditor' ?
                        getCkEditor(i, item)
                        : item.type === 'empty' ?
                          <div> </div>
                          : item.type === 'radio' ?
                            getRadio(i, item)
                            : item.type === 'permission' ?
                              // getRolePermissions()
                              getScreenPermissions()
                              : item.type === 'autoComplete' ?
                                getAutoComplete(i, item)
                                : item.type === 'relateAutoComplete' ?
                                  getAutoComplete(i, item)
                                  : item.type === 'textarea' ?
                                    getTextArea(i, item)
                                    : item.type === 'buttonGroup' ?
                                      item.options && item.options.length > 0 ? getButtonGroup(i, item) : null
                                      : item.type === 'multipleprofile' ?
                                        getMultiplePhotoUpload(i, item) :
                                        item.type == "password" ?
                                          getPassword(i, item)
                                          : item.type == "encryptedField" ?
                                            getPassword(i, item)
                                            /**@CheckBox */
                                            : item.type == 'checkbox' ?
                                              getCheckbox(i, item)
                                              : getDefault(i, item)

          }
        </div>
      </div>

    )
  }

  let getFields = () => {
    let allFields = <></>
    let item;
    for (let i = 0; i < formFields.length; i++) {
      item = formFields[i];

      if (formType == 'regenerate' && !item.editInRegenerateForm) {
        item.isDisable = true;
      }
      if (item.show === false || (item.isAddFormHidden === true && formType === 'add') || (item.isEditFormHidden === true && formType === 'edit')) {

      } else if (formType == 'regenerate' && !item.showInRegenerateForm) {

      } else {
        allFields = <>{allFields}
          {getItemField(item, i)}
        </>
      }
    }
    return allFields;
  }
  let setSlno = async (actionType) => {
    let { totalRecords, first, rows, onPageChange, isWeb } = props;
    let sLno = slno;
    if (actionType === 'back') {
      if (sLno !== 0) {
        setSslno((slno) => slno - 1);
        handleNextAndBackActions(sLno - 1)
      } else {
        setSslno(slno + 1);
      }
    } else if (actionType === 'next') {
      let total = '';
      total = props.allUsersData.length;
      if (sLno !== total) {
        setSslno((slno) => slno + 1);
        setColored(true)
        handleNextAndBackActions(sLno + 1);
      } else {
        setSslno(slno);
      }
    }
  }

  let getPaginationWithIcons = () => {
    let { first, rows, page, allUsersData } = props;
    let totalLength = (first && first !== 0 && allUsersData.length >= 20) ? (allUsersData.length + first) : allUsersData.length <= 20 ? first + allUsersData.length : allUsersData.length;

    let isSelectedData = false;
    for (let i = 0; i < allUsersData.length; i++) {
      if (allUsersData[i].Sno === selectedData['Sno']) {
        isSelectedData = true
      }
    }

    return (
      <div className='d-flex h-100'>
        <div className='pagenumber-indicator'>
          {slno === 0 ? 1 : slno} / {totalLength}&nbsp;&nbsp;
        </div>
        <div>
          <ButtonGroup className='mb-0'>
            <Button color="primary"
              outline
              disabled={!isSelectedData || (slno === (page - 1) * rows + 1) ? true : false}
              size="sm"
              style={{ borderTopRightRadius: 0, borderBottomRightRadius: 0 }}
              className="p-1 ml-auto mt-1 mb-0"
              onClick={() => setSlno('back')}
            >
              <FontAwesomeIcon
                icon='chevron-left'
                className='pl-1' size='lg'
                data-toggle="tool-tip" title="List"

              />
            </Button>
            <Button color="primary"
              outline
              disabled={!isSelectedData || (slno === totalLength) ? true : false}
              size="sm"
              style={{ borderTopLeftRadius: 0, borderBottomLeftRadius: 0 }}
              className="p-1 ml-auto mt-1 mb-0"
              onClick={() => setSlno('next')}
            >
              <FontAwesomeIcon
                icon='chevron-right'
                className='pl-1' size='lg'
                data-toggle="tool-tip" title="List"

              />
            </Button>
          </ButtonGroup>
        </div>

      </div>
    )
  }

  //getModalBody
  let getModalBody = () => {
    return (
      <ModalBody className="modal__body mb-0 p-0">
        <Card className='pb-0 '>
          <CardBody className='tableCardBody'>
            <form onSubmit={handleSubmit(submit)} autoComplete={'off'}>
              <Loader loader={isLoading} />
              <div className="row form" >
                {getFields()}
                {sessionExpiryModal ?
                  <SessionExpiryModal
                    SOpen={sessionExpiryModal}
                  />
                  : null
                }
                {props.getDependentFields && props.getDependentFields(props.type, formType)}
              </div>
              {getButtonToolbar()}
            </form>
          </CardBody>
        </Card>
      </ModalBody>
    )
  }

  const onErrors = (data) => {
  }

  //getScreenBody
  let getScreenBody = () => {
    return (
      <form onSubmit={handleSubmit(submit, onErrors)} autoComplete={'off'}>
        <Loader loader={isLoading} />
        <div className={props.displayViewOfForm == 'sideForm ' ? "col-12 row form" : formType === 'add' ? "row form pt-3" : "row form "}
          style={{
            scrollbarWidth: "none",
            msOverflowStyle: "none"
          }}
        >
          {getFields()}
          {sessionExpiryModal ?
            <SessionExpiryModal
              SOpen={sessionExpiryModal}
            />
            : null
          }
          {props.getDependentFields && props.getDependentFields(props.type, formType)}
        </div>
        {getButtonToolbar()}
      </form>
    )
  }

  //getModalView
  let getModalView = () => {
    let { handleSubmit } = props;
    let modalClass = classNames({
      'modal-dialog--colored': colored,
      'modal-dialog--header': header,
    });
    return (
      <Dialog
        visible={props.openFormModal}
        onHide={closeFormModal}
        draggable={false}
        style={{ width: ['Files', 'Folders', 'SharedFiles'].includes(props.type) ? '35vw' : '', maxwidth: "70vw" }}
        header={getModalHeader()}
        closeOnEscape={false}
        focusOnShow={false}
        blockScroll={false}
      >
        {formType === 'view' ?
          <ModalBody className={`modal__body mb-0 ${props.type == 'topic' ? "overflow-hidden" : ""}`}>
            <Card className='pb-0 '>
              <CardBody>
                {props.type == 'topic' ?
                  <>
                    {contentGenerationBody()}
                  </> : <>{getViewBody()}
                    {getEditButton()}</>
                }
              </CardBody>
            </Card>
          </ModalBody> : getModalBody(handleSubmit)
        }
      </Dialog >
    )
  }
  let cancelUserPwdResetModal = async () => {
    setOpenUserPasswordResetModal(false);
    setActions('')
  }
  let getUserPasswordResetModal = () => {
    return (
      <UserPasswordResetModal
        openUserPasswordResetModal={openUserPasswordResetModal}
        userId={editRowDataID}
        cancelReset={cancelUserPwdResetModal}
        entityType={props.entityType}
      />
    )
  }
  let getHeader = () => {
    if (props.displayViewOfForm == "sideForm") {
      return <>
        <h3 style={{ textTransform: 'capitalize', color: '#12225f' }}>
          <b>
            {formType == "add" ? `Add ${props.type}` : formType == 'edit' ? `Edit ${props.type}` : formType == 'regenerate' ? "Rengenerate Test Case using AI" : ''}
          </b>
        </h3>
      </>
    }
    if (props.displayViewOfForm != "sideForm") {
      return (
        <div className='d-flex'>
          <div className='col-12 px-0 pb-1'>
            <span className='float-left pt-2'>
              <h4 style={{ textTransform: 'capitalize' }}><b>
                <Link to={props.routeTo.startsWith("/") ? props.routeTo : `/${props.routeTo}`} onClick={closeFormModal}>
                  {props.type == "agreementFiles" ? props.currentTemplate?.fileName : props.type}
                </Link>
                {formType !== 'add' && displayBreadCrumbValue ? ` / ${displayBreadCrumbValue} ` : null}
              </b> </h4>
            </span>
          </div>
        </div>
      )
    }
  }
  let submitActionsData = async (method, url) => {
    return fetchMethodRequest(method, url)
      .then(async (response) => {
        let sessionexpired = localStorage.getItem('sessionexpired')
        if (sessionexpired == "true") {
          setSessionExpiryModal(true);
        }
        setOpenDeleteModal(false);
        setActions('');
        if (response && response.respCode) {
          showToasterMessage(response.respMessage, 'success');
          // await props.getDataFromServer(props.filterCriteria);
          await props.closeFormModal();
          await handleNextAndBackActions();
          // props.closeFormModal('save');
        } else if (response && response.errorMessage) {
          showToasterMessage(response.errorMessage, 'error');
        }
      }).catch((err) => {
        return err;
      });
  }

  let handleActions = async () => {
    let apiUrl = props.apiUrl, url = '', method = '';
    if (confirmType === 'Delete') {
      method = 'DELETE';
      url = `${apiUrl}/${editRowDataID}`;
      submitActionsData(method, url)
    }
    if (confirmType === 'Block') {
      method = 'PUT';
      url = `${apiUrl}/block/${editRowDataID}?block=true`;
      submitActionsData(method, url)
    }
    if (confirmType === 'ResetPassword') {
      setOpenUserPasswordResetModal(true);
      setOpenDeleteModal(false);
    }

  }

  // conformation for delete item
  let deleteConfirmAction = async (rowData, selectActions) => {
    setOpenDeleteModal(true);
    setSelectActions(selectActions);
  }
  let confirmActionType = async (type) => {
    if (type === 'Delete') {
      await setConfirmType(type);
      await setConfirmModalText('Are you sure want to Delete')
      deleteConfirmAction()
    } else if (type === 'Block') {
      await setConfirmType(type);
      await setConfirmModalText('Are you sure want to Block')

      deleteConfirmAction()
    } else if (type === 'ResetPassword') {
      await setState({
        confirmType: type,
        confirmModalText: 'Are you sure want to Reset Password',
        openUserPasswordResetModal: true,
        openDeleteModal: false
      })
      await setConfirmType(type);
      await setConfirmModalText('Are you sure want to Reset Password');
      await setOpenUserPasswordResetModal(true);
      await setOpenDeleteModal(false);

    }
  }

  //onActionsChange
  let onActionsChange = async (event, type) => {
    if (type == 'dropdownFilter') {
      await setState({
        [event.target.name]: event.target.value,
      })
      confirmActionType(event.target.value)
    }
  }

  let getViewBody = () => {
    let { t } = props;
    if (customViewData && props.customViewModal) {
      return customViewData && props.customViewModal(customViewData);
    }

    const ReadMore = ({ content, limit = 300, isHtml = false }) => {
      const [isExpanded, setIsExpanded] = useState(false);

      const stripHtml = (html) => {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        return doc.body.textContent || "";
      };

      const textContent = isHtml ? stripHtml(content) : content;
      const shouldTruncate = textContent.length > limit;

      if (!shouldTruncate) {
        return isHtml ? <div dangerouslySetInnerHTML={{ __html: content }} /> : <p>{content}</p>;
      }

      return (
        <div className="read-more-wrapper">
          <div className={`read-more-content ${isExpanded ? 'expanded' : 'collapsed'}`}>
            {isHtml ? <div dangerouslySetInnerHTML={{ __html: content }} /> : <p>{content}</p>}
          </div>
          <button className="read-more-toggle" onClick={() => setIsExpanded(!isExpanded)}>
            {isExpanded ? 'Show Less' : 'Read More...'}
          </button>
        </div>
      );
    };

    return (
      <div className="standard-view-body">
        <div className='row mb-3'>
          <div className='col-12 text-right'>
            {originalTableFields && originalTableFields.length > 0 ? originalTableFields.map((item, index) => {
              return item.fieldType === 'Badge' && item.options && item.options.length > 0 ? item.options.map((optionsItem, optionsIndex) => {
                return (
                  <Button key={optionsIndex} color='primary' className="ms-1 p-button-sm" onClick={() => saveDataToServer({ "status": optionsItem.value })} disabled={userStatus === optionsItem.value ? true : false}>{optionsItem.value}</Button>)
              }) : null
            }) : null}
          </div>
        </div>
        {rowData && rowData.length > 0 ?
          <div className="view-grid">
            {rowData.map((item, i) => {
              const isLongText = item.value && String(item.value).length > 200;
              return (
                item.value !== "" && item.value !== null && item.label !== 'SNo' && (item.value?.length && item.value.length > 0) ?
                  <div className={`view-item ${isLongText ? 'col-12 full-width' : displayViewOfForm == "sideForm" ? 'col-12' : 'col-sm-6'}`} key={i}>
                    <div className="view-field">
                      <div className="field-label">{item.label}</div>
                      <div className="field-value">
                        {isLongText ? (
                          <ReadMore content={item.value} isHtml={item.fieldType === 'innerHTML'} limit={200} />
                        ) : (
                          (typeof (item.value) === 'string') && item.fieldType && item.fieldType == 'dropDown' ?
                            getBadgeData(item, item.value)
                            : !(typeof (item.value) === 'string') && item.fieldType && item.fieldType == 'dropDown' ?
                              getMultiSelectBadge(item, item.value)
                              : item.value
                        )}
                      </div>
                    </div>
                  </div> : null
              );
            })}
          </div>
          : <div className="text-center p-4">No data available</div>
        }
      </div>
    )
  }

  const generateContentByTopic = async (topicId) => {
    const toastId = showToasterMessage("Generating Context...", "loading");
    if (!topicId) return
    setIsLoading(true);
    let method = "PUT"
    let apiUrl = `topics/generate/${topicId}`
    closeFormModal()
    return fetchMethodRequest(method, apiUrl, {})
      .then(async (response) => {
        let sessionexpired = await localStorage.getItem('sessionexpired')
        if (sessionexpired === "true") {
          setSessionExpiryModal(true);
        }
        if (response && response.respCode) {
          setSelectedData(response.topic);
          setTimeout(() => {
            toast.update("loader-toast", {
              render: "Content Generated!",
              type: "success",
              isLoading: false,
              autoClose: 3000,
            });
          }, 100)
          if (response.topic) {
            props.replaceUpdatedData(response[props.type]);
          }
        } else if (response && response.errorMessage) {
          setTimeout(() => {
            toast.update("loader-toast", {
              render: "Content Generation Failed",
              type: "error",
              isLoading: false,
              autoClose: 5000,
            });
          }, 1000);
        }

      }).catch((err) => {
        return err;
      })
  }

  const handleCopyClick = (text) => {
    text = stripHtmlTags(marked(text));
    navigator.clipboard.writeText(text).then(() => {
      SetCopyText(true);
      setTimeout(() => {
        SetCopyText(false)
      }, 3000);
    }, () => {
      SetCopyText(false);
    });
  };


  let contentGenerationBody = () => {
    let { t } = props;
    if (!selectedData) return

    const topicName = selectedData?.topic || "No Topic";
    const createdDate = moment(selectedData?.created_at).format('MMMM Do YYYY, h:mm a') || "";
    const contentText = selectedData?.content || "No content available";
    const showButton = selectedData?.content ? false : true;
    const imagePath = selectedData?.imagePath || null;
    const downloadAsPdf = () => {
      const element = document.querySelector('.content-scroll-area');
      const options = {
        margin: 1,
        filename: `${topicName.replace(/\s+/g, '_')}_Content.pdf`,
        image: { type: 'jpeg', quality: 0.98 },
        html2canvas: { scale: 2 },
        jsPDF: { unit: 'in', format: 'letter', orientation: 'portrait' }
      };
      html2pdf().from(element).set(options).save();
    };

    const downloadAsDocx = async () => {
      const doc = new Document({
        sections: [{
          properties: {},
          children: [
            new Paragraph({
              children: [
                new TextRun({
                  text: topicName,
                  bold: true,
                  size: 32,
                }),
              ],
            }),
            new Paragraph({
              children: [
                new TextRun({
                  text: `Created on: ${createdDate}`,
                  italics: true,
                  size: 20,
                }),
              ],
            }),
            new Paragraph({
              text: "",
            }),
            ...contentText.split('\n').map(line => new Paragraph({
              children: [new TextRun({ text: line, size: 24 })]
            })),
          ],
        }],
      });

      const blob = await Packer.toBlob(doc);
      saveAs(blob, `${topicName.replace(/\s+/g, '_')}_Content.docx`);
    };

    const topicId = selectedData?._id


    return (
      <div className="content-generation-view">
        <div className="topic-header-section mb-2">
          <div className="d-flex justify-content-between align-items-start">
            <div className="topic-info">
              <h1 className="topic-title">{topicName}</h1>
              {createdDate && (
                <div className="topic-meta">
                  <i className="pi pi-calendar me-1"></i>
                  <span>Created on {createdDate}</span>
                </div>
              )}
            </div>
            <div className="topic-actions d-flex gap-2">
              {!showButton && (
                <>
                  <Button
                    className="p-button-outlined p-button-danger p-button-sm"
                    icon="pi pi-file-pdf"
                    tooltip="Download as PDF"
                    onClick={downloadAsPdf}
                  />
                  <Button
                    className="p-button-outlined p-button-info p-button-sm"
                    icon="pi pi-file-word"
                    tooltip="Download as DOCX"
                    onClick={downloadAsDocx}
                  />
                  <Button
                    className="p-button-outlined p-button-secondary p-button-sm"
                    icon={copyText ? "pi pi-check" : "pi pi-copy"}
                    label={copyText ? 'Copied' : 'Copy Content'}
                    onClick={() => handleCopyClick(contentText)}
                  />
                </>
              )}
            </div>
          </div>
        </div>

        <div className="content-body-section card-style">
          <div className="content-scroll-area">
            {showButton ? (
              <div className="empty-content-state text-center py-5">
                <i className="pi pi-sparkles mb-3" style={{ fontSize: '2rem', color: '#12225f' }}></i>
                <h3>No content generated yet</h3>
                <p className="text-muted mb-4">Click the button below to generate high-quality AI content for this topic.</p>
                <Button
                  className="p-button-raised"
                  onClick={() => generateContentByTopic(topicId)}
                  style={{ background: '#12225f', border: 'none' }}
                >
                  <i className="pi pi-bolt me-2"></i>
                  Generate Content
                </Button>
              </div>
            ) : (
              <div
                className="ai-generated-text content-view"
                dangerouslySetInnerHTML={{ __html: marked(contentText) }}
              />
            )}
          </div>
        </div>

        {/* {imagePath && (
          <div className="topic-image-section mt-4 card-style">
            <h3 className="section-title">Associated Visual</h3>
            <div className="image-container text-center">
              <img
                src={config.imgUrl + imagePath}
                alt={topicName}
                className="img-fluid rounded-3"
                style={{ maxHeight: '400px', objectFit: 'contain' }}
              />
            </div>
          </div>
        )} */}
      </div>
    );

    {/* Right Side - Image */ }
    {/* <div className="col-lg-4 col-md-5 col-12">
              <div className="image-right">
                {imagePath ? (
                  <div className="image-container">
                    <img
                      src={config.imgUrl + imagePath}
                      alt={topicName}
                      className="img-fluid topic-image"
                    />
                    <div className="image-caption text-muted mt-2">
                      <small>Topic: {topicName}</small>
                    </div>
                  </div>
                ) : (
                  <div className="no-image-placeholder">
                    <i className="fas fa-image fa-3x mb-3 text-muted"></i>
                    <p className="text-muted mb-0">No Image Available</p>
                  </div>
                )}
              </div>

            </div> */}

  };

  let getBadgeData = (element, value) => {
    let mcolor = props.getColorFromOptions(element.options, value);
    return (<Badge color={mcolor} pill >{value}</Badge>)
  }

  const getMultiSelectBadge = (element, value) => {
    let mcolor = props.getColorFromOptions(element.options, value);
    return (
      <div>
        {value.map((badge, index) => (
          <Badge key={index} color={mcolor} pill style={{ margin: '1px' }}>
            {badge}
          </Badge>
        ))}
      </div>
    )
  }

  //sorting fields
  let sortChange = (event) => {
    setSelectedRows('')
    let newSortCount = sortCount;
    if (event && event['sortField']) {
      newSortCount = newSortCount == 0 ? newSortCount + 1 : 0;
      let sortField = event['sortField'];
      let filters = filterCriteria;
      filters['direction'] = newSortCount == 0 ? "desc" : 'asc';
      filters['sortfield'] = sortField;
      setSortCount(newSortCount);
      setFilterCriteria(filters);
      getActivities(filters, selectedId);
    }
  }

  let getColumns = (e, d) => {
    let { t } = props;
    let tablefieldsToShow = getTableFields();
    if (tablefieldsToShow && tablefieldsToShow.length > 0) {
      return tablefieldsToShow.map((item, i) => {
        let column = (item.show &&
          <Column key={item.field + i}
            style={{
              maxwidth: item.width,
              padding: 2,
            }}
            bodyStyle={{
              textOverflow: 'ellipsis',
              overflow: 'hidden',
              whiteSpace: 'nowrap',
              textAlign: item.field == 'status' || item.field == 'role' ? 'center' : item.textAlign
            }}
            field={item.field}
            header={t(item.header)}
            body={self.changeFieldValues}
            headerStyle={{
              padding: 4, fontWeight: 500, width: item.width, fontSize: 13,
              color: config.whiteColor, backgroundColor: config.templateColor
            }}
            filter={false}
            sortable={item.sortable ? true : false}
            filterPlaceholder={item.placeholder ? item.placeholder : 'search'}

            selectionMode={item.selectionMode}
          />
        )
        return column;
      })
    }
  }
  let getDataTable = () => {
    let dt;

    return (
      <DataTable
        ref={(el) => dt = el}
        value={activitiesData}
        totalRecords={totalRecordsLength}
        paginator={false}
        lazy={true}
        resizableColumns={true}
        columnResizeMode="expand"
        onSort={sortChange}
        globalFilter={props.globalFilter}
        onFilter={props.onFilterChange}
        scrollable={true}
        selection={false}
        scrollHeight='1000px'
        // style={{ marginTop: 0 }}
        emptyMessage={configMessages.noRecords}
        sortMode="single"
        // sortField="fname"
        // sortOrder={-1}
        // selectionMode={'multiple'}
        metaKeySelection={false}
        loading={isLoading}
        style={activitiesData && activitiesData.length == 0 ?
          { textAlign: 'center' }
          : null}
      >
        {getColumns()}
      </DataTable>
    )
  }
  let getActivitiesHeader = () => {
    let { t } = props
    return (
      <div className='col-12  pb-1'>
        <span className='float-left pt-2'>
          <h4 style={{ textTransform: 'capitalize' }}><b>

            <Link to={props.routeTo.startsWith("/") ? props.routeTo : `/activities`} onClick={closeFormModal}>
              {t('Activities')}
            </Link>
            {formType !== 'add' && displayBreadCrumbValue ? ` / ${displayBreadCrumbValue} ` : null}
          </b> </h4>
        </span>
        <span className='float-right pt-2'>
          {/* {getPaginator()} */}
        </span>
      </div>
    )
  }

  const getAgreementHeader = () => {
    return (
      <div className="d-flex justify-content-center" style={{ margin: '24px 0 16px' }}>
        <h3
          style={{
            fontWeight: 600,
            fontSize: '1.75rem',
            color: '#0b1c4fff',
            borderBottom: '3px solid #a934c1ff',
            paddingBottom: '8px',
            display: 'inline-block',
            textTransform: 'uppercase',
            letterSpacing: '0.5px',
            margin: 0,
          }}
        >
          {props.currentTemplate?.fileName}
        </h3>
      </div>
    );
  }
  const generateAgreementHTML = () => {
    const formValues = watch();

    const variableTypeMap = {};
    if (props.currentTemplate?.templateVariables) {
      props.currentTemplate.templateVariables.forEach(v => {
        variableTypeMap[v.name] = v.type;
      });
    }

    const escapeHtml = (text) => {
      if (!text) return '';
      return String(text)
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;");
    };

    const formatValue = (value, type) => {
      if (value === undefined || value === null) return "";

      if (type === "date" && value instanceof Date) {
        const d = String(value.getDate()).padStart(2, "0");
        const m = String(value.getMonth() + 1).padStart(2, "0");
        const y = value.getFullYear();
        return `${d}-${m}-${y}`;
      }

      return String(value);
    };

    const replaceVariables = (content) => {
      return content.replace(/\{\{([^}]+)\}\}/g, (match, variableName) => {

        const value = formValues[variableName];
        const type = variableTypeMap[variableName];
        const isFocused = variableName === focusedField; // field currently being edited

        let displayValue = match;

        if (value !== undefined && value !== "") {
          displayValue = escapeHtml(formatValue(value, type));
        }

        if (isFocused) {
          return `<span class="highlight" data-variable="${variableName}">${displayValue}</span>`;
        }

        return displayValue;
      });
    };
    const sortedPages = [...props.currentTemplate.templatePages].sort(
      (a, b) => a.page - b.page
    );

    let finalHTML = "";

    sortedPages.forEach(page => {
      finalHTML += replaceVariables(page.content);
    });

    return finalHTML;
  };
  let getAgreementFileView = () => {

    const html = generateAgreementHTML();

    return (
      <>
        <div
          className="agreement-page"
          dangerouslySetInnerHTML={{ __html: html }}
          style={{
            fontFamily: 'Georgia, "Times New Roman"',
            fontSize: '14px',
            lineHeight: '1.8'
          }}
        />
      </>
    );
  };
  //getScreenView
  let getScreenView = () => {
    let { handleSubmit } = props;
    return (
      <div>

        {props.openFormModal ? <div
          style={{
            maxHeight: "calc(100vh - 100px)",
            overflowY: "scroll",
            scrollbarWidth: "none",
            msOverflowStyle: "none"
          }}
        >
          <div className='d-flex justify-content-between pb-2 mx-1' >

            <div >
              {props.type === 'agreementFiles' ? getAgreementHeader() : getHeader()}
            </div>
            <div >
              {formType !== 'add' && formType !== "regenerate" && formType !== "edit" && getPaginationWithIcons()}
            </div>

          </div>
          <Row className="g-0 gap-4 ms-3" style={{ backgroundColor: '#f5f7fa' }} >
            <div className={props.type == "agreementFiles" ? "col-4 row form " : "row form"} style={{ maxHeight: "calc(100vh - 200px)", overflowY: "scroll", backgroundColor: '#ffffffff', }}>
              {formType !== 'view' ? getScreenBody(handleSubmit) : getViewBody()}
            </div>
            {props.type === 'agreementFiles' ? <div ref={previewRef} className={props.type == "agreementFiles" ? "col-8 row form" : "row form"} style={{ maxHeight: "calc(100vh - 200px)", overflow: "scroll", }}>
              {getAgreementFileView()}
            </div> : null}

          </Row>
          {formType === 'view' && props.editRequired ? getEditButton() : null}
          {formType !== 'add' && formType !== 'edit' && formType != 'regenerate' ?

            <div>
              {JSON.parse(localStorage.getItem('rolePermissions')).Activities != config.noView ?  // Activities table won't show if there is no activities screen
                <div>
                  <div className='row'>
                    {getActivitiesHeader()}
                  </div>
                  <div className='row'>
                    <div className='col-sm-12'>
                      {getDataTable()}
                      {getPaginator()}
                    </div>
                  </div>
                </div> : null
              }
            </div> : null
          }
        </div> : null
        }
      </div>
    );
  }

  let { displayViewOfForm } = props;
  return (
    <div>
      {displayViewOfForm === 'modal' ?
        getModalView() : displayViewOfForm === 'screen' || displayViewOfForm == 'sideForm' ?
          getScreenView() : null
      }
      {openDeleteModal ? getDeleteRowModal() : null}
      {openUserPasswordResetModal ? getUserPasswordResetModal() : null}
    </div>
  );

}

export default withTranslation('common')(FormModal);